import type { Nullable } from "@bounce/util"

type UseStoreReviewCountArgs = {
  store: Nullable<{ reviewCount: number }>
}

export const useStoreReviewCount = ({ store }: UseStoreReviewCountArgs) => {
  if (!store) {
    return null
  }

  const { reviewCount } = store

  if (reviewCount < 100) {
    return reviewCount
  }

  if (reviewCount < 500) {
    return `${100}+`
  }

  if (reviewCount < 1000) {
    return `${500}+`
  }

  return `${1000}+`
}
